// extracted by css-extract-rspack-plugin
export default {"EmptyStateFooter":"UP2cm"};